import { render, staticRenderFns } from "./InvPD.vue?vue&type=template&id=f71322b2"
import script from "./InvPD.vue?vue&type=script&lang=js"
export * from "./InvPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports